export const EVENTS = {
  START_NEW_CHAT: {
    trigger: 'plus_icon',
    action: 'start_new_chat',
    target_component: 'UzairChat',
    data: null,
  },

  OPEN_FILE_POPUP: {
    trigger: 'file_upload_icon',
    action: 'open_file_upload',
    target_component: 'UzairSidebar',
    data: null,
  },

  OPEN_SEARCH_CHAT_POPUP: {
    trigger: 'search_icon',
    action: 'open_search_chat_popup',
    target_component: 'UzairSidebar',
    data: null,
  },

  OPEN_AND_LOAD: {
    trigger: 'history_item',
    action: 'open_and_load',
    target_component: 'UzairChat',
    data: null,
  },

  ADD_NEW_CHAT_TO_LIST: {
    trigger: 'starting_new_chat',
    action: 'add_new_chat_to_list',
    target_component: 'ChatHistoryList',
    data: null,
  },

  UPDATE_CHAT_SUBJECT: {
    trigger: 'new_message_in_chat',
    action: 'update_chat_subject',
    target_component: 'ChatHistoryList',
    data: null,
  },

  ON_CHAT_DELETED: {
    trigger: 'on_chat_deleted',
    action: 'clear_active_chat_if_deleted',
    target_component: 'UzairChat',
    data: null,
  },
};


export const FEEDBACK_REACTIONS = {
  THUMPS_UP: 1,
  THUMPS_DOWN: 2,
  ANGRY: 3,
  NORMAL: 4,
  HAPPY: 5,
};


export class ShortcutName {
  static LIST_WHAT_YOU_CAN_DO = 'listWhatYouCanDo'

  static PROPERTY_DESCRIPTION = 'propertyDescription';

  static VENDOR_FEEDBACK = 'vendorFeedback';

  static CONTENT = 'content';
}
